import React from "react";
import PropTypes from "prop-types";

import {
    ShapeIconSquare,
    ShapeIconRounded,
    ShapeIconCircle,
    ShapeIconRing,
    ShapeStatusContainer
} from "./styles";
import BodyText from "core/BodyText";

import { SHAPES } from "./constants";

const ShapeStatus = ({ currentShape }) => {
    let Shape;
    let text = "";

    if (currentShape === SHAPES.SQUARE) {
        Shape = ShapeIconSquare;
        text = "Square";
    }

    if (currentShape === SHAPES.ROUNDED) {
        Shape = ShapeIconRounded;
        text = "Rounded";
    }

    if (currentShape === SHAPES.CIRCLE) {
        Shape = ShapeIconCircle;
        text = "Circle";
    }

    if (currentShape === SHAPES.RING) {
        Shape = ShapeIconRing;
        text = "Ring";
    }

    return (
        <ShapeStatusContainer>
            <Shape />
            <BodyText size="xs">{text}</BodyText>
        </ShapeStatusContainer>
    );
};

ShapeStatus.propTypes = {
    currentShape: PropTypes.oneOf(Object.values(SHAPES)).isRequired
};

export default ShapeStatus;
